export default __webpack_public_path__ + "static/media/ci_resources.2d215296.png";